
const API_ROOT = 'https://app-node.talkdev.com:3021';
const API_ROOTT= 'http://localhost:3021';


const webPath = 'https://talkdev.com'
// const webPath = 'https://talkdev.ondotmail.com'


export { API_ROOT,API_ROOTT, webPath};